<div>
    <app-vwsa-text weight="bold" text="Owner Details"></app-vwsa-text><br />
    <div class="column__list">
        <div class="card__list">
            <app-vwsa-text-input inputId="ownerFirstName" label="First Name" value="{{ownerInfo?.firstName}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="ownerLastName" label="Last Name" value="{{ownerInfo?.lastName}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="ownerMobile" label="Mobile Number" value="{{ownerInfo?.mobileNumber}}" disabled="true">
            </app-vwsa-text-input>
        </div>
        <div class="card__list">
            <app-vwsa-text-input inputId="ownerEmail" label="Email Address" value="{{ownerInfo?.email}}" disabled="true">
            </app-vwsa-text-input>
        </div>
    </div>

    <app-vwsa-text weight="bold" text="Vehicle Details"></app-vwsa-text><br />
    <app-vwsa-text text="Please select a vehicle for which you would like to purchase a plan.*">
    </app-vwsa-text>
    <br />
    <p-table [value]="ownerInfo?.vehicleDetails" [(selection)]="selectedVehicleDetail" (onRowSelect)="onSelectVehicle()" [lazy]="true" (onLazyLoad)="onLazyLoad()">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3rem"></th>
                <th>Model</th>
                <th style="width: 6rem">Year</th>
                <th style="width: 11rem;">VIN Number</th>
                <th>Warranty</th>
                <th>Plan Type</th>
                <th>Plan End Date</th>
                <th>Plan End KMs</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vehicle>
            <tr [pSelectableRow]="vehicle">
                <td>
                    <p-tableRadioButton [value]="vehicle"></p-tableRadioButton>
                </td>
                <td><span class="ui-column-title">Model</span>{{vehicle.modelDescription}}</td>
                <td><span class="ui-column-title">Year</span>{{vehicle.year}}</td>
                <td><span class="ui-column-title">VIN Number</span>{{vehicle.vin}}</td>
                <td><span class="ui-column-title">Warranty</span>{{vehicle.warrantyStatus}}</td>
                <td><span class="ui-column-title">Plan Type</span>{{vehicle.planType}}</td>
                <td><span class="ui-column-title">Plan End Date</span>
                    {{(vehicle.planEnd != '0000-00-00') ? (vehicle.planEnd | date:'dd MMMM yyyy') : ''}}
                </td>
                <td><span class="ui-column-title">Plan End KMs</span>{{vehicle.currentPlanEndKM}}</td>
            </tr>
        </ng-template>
    </p-table>

    <br /><br /><br />
    <div class="column__list">
        <div class="card__list">
            <div class="tooltip-container">
                <app-vwsa-text text="Odometer Reading*">
                </app-vwsa-text>
                <app-vwsa-text-input id="odometerReading" inputId="odometerReading" label="" [(value)]="currentOdometer" (valueChange)="onCurrentOdometerChanged()"
                    (onblur)="onCurrentOdometerChanged()" validationMessage="{{odometerValidationMessage}}" placeholder="Please provide an accurate odometer reading">
                </app-vwsa-text-input>
                <app-tooltip class="tooltip-top-right" tooltipText="{{contentTooltips | ContentTooltip:'Odometer Reading'}}"></app-tooltip>
            </div>
        </div>
        <div class="card__list"></div>
        <div class="card__list"></div>
    </div>

    <br />
    <div *ngIf="serviceHistoryLoaded">
        <app-vwsa-text weight="bold" text="Vehicle Service History">
        </app-vwsa-text>
        <p-table [value]="serviceHistories" *ngIf="true">
            <ng-template pTemplate="header">
                <tr>
                    <th>Service Date</th>
                    <th>Dealer Name</th>
                    <th>Service Description</th>
                    <th>Odometer</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-history>
                <tr>
                    <td><span class="ui-column-title">Service Date</span>
                        {{(history.serviceDate != '0000-00-00') ? (history.serviceDate | date:'dd MMMM yyyy') : ''}}
                    </td>
                    <td><span class="ui-column-title">Dealer Name</span>{{history.dealerName}}</td>
                    <td><span class="ui-column-title">Service Description</span>{{history.serviceDescription}}</td>
                    <td><span class="ui-column-title">Odometer</span>{{history.odometer | number}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns?.length">
                        No service history found
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <br />
    </div>

    <div>
        <app-vwsa-text appearance="copy0100" text="* Indicates required fields"></app-vwsa-text><br />
        <app-vwsa-button text="Continue" (click)="onContinueToPlan()" [disabled]="!canContinueToPlan"></app-vwsa-button>
        <br /><br />
        <app-vwsa-button text="Back" (click)="onBackToEnterCustomerDetails()" variant="secondary"></app-vwsa-button>
    </div>
</div>